<form [formGroup]="formGroup" [bitSubmit]="submit">
  <bit-form-field class="!tw-mb-1">
    <bit-label>{{ "verificationCode" | i18n }}</bit-label>
    <input
      bitInput
      type="text"
      id="verificationCode"
      name="verificationCode"
      formControlName="code"
      appInputVerbatim
      (paste)="onPaste($event)"
    />
  </bit-form-field>

  <button
    bitLink
    type="button"
    linkType="primary"
    (click)="resendOTP()"
    [disabled]="disableRequestOTP"
    class="tw-text-sm"
  >
    {{ "resendCode" | i18n }}
  </button>

  <div class="tw-grid tw-gap-3 tw-mt-4">
    <button
      bitButton
      bitFormButton
      buttonType="primary"
      type="submit"
      [block]="true"
      [disabled]="formGroup.invalid"
    >
      {{ "continueLoggingIn" | i18n }}
    </button>

    @if (showBackButton) {
      <div class="tw-text-center">{{ "or" | i18n }}</div>

      <button type="button" bitButton block buttonType="secondary" (click)="goBack()">
        {{ "back" | i18n }}
      </button>
    }
  </div>
</form>
